module.exports = __webpack_public_path__ + "static/media/Construction-and-Infrastructure.af7bfd3c.jpg";